import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var Skillsets = require("lib/academic/Skillsets");
var ReactTooltip = require("react-tooltip");
var LoadingButton = require("components/utility/LoadingButton");
var BookSearchModal = require("components/reading/books/BookSearchModal");
var ValidatingInput = require("components/utility/ValidatingInput");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("users/teachers/question_customizer.scss");

@connect(
	(state, props) => {
		var prefs = RosterSelectors.globalStudentListPrefs({ state });
		return {
			preferTeacherPracticeQuestions: prefs.prefer_teacher_practice_questions
		}
	},

	(dispatch, props) => ({
		onChange: (prefsUpdate, message) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch(RosterActions.updateAllStudentListPrefs({
				currentUserID: CurrentUser.get().id,
				update: prefsUpdate
			}))
		}
	})
)
class QuestionCustomizer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			questions: null, addingQuestion: false, 
			selectedQuestionType: ALL_TEXTS, selectedBook: null,
			loading: false, editingID: null
		};
		LuckyOrangeClient.tagComponent("QuestionCustomizer");
	}

	toggleAddingQuestion(e) {
		$wr.nope(e)
		this.setState({ addingQuestion: !this.state.addingQuestion,
			selectedQuestionType: ALL_TEXTS, selectedBook: null });
	}

	toggleEditingQuestion(questionID) {
		if (this.state.editingID == questionID) {
			this.setState({ editingID: null });
		} else {
			this.setState({ editingID: questionID });
		}
	}

	selectQuestionType(questionType) {
		if (questionType == SPECIFIC_TEXT) {
			this.refs.bookSearchModal.show();
		} else {
			this.setState({ selectedQuestionType: questionType, selectedBook: null });

			if (this.refs.skillsetDropdown != undefined) {
				var skillsetHasFiction = Skillsets.hasFiction(this.refs.skillsetDropdown.val());
				var skillsetHasNonFiction = Skillsets.hasNonFiction(this.refs.skillsetDropdown.val());

				if ((!skillsetHasFiction) && (questionType == ALL_FICTION_TEXTS)) {
					this.refs.skillsetDropdown.reset();
				}

				if ((!skillsetHasNonFiction) && (questionType == ALL_NONFICTION_TEXTS)) {
					this.refs.skillsetDropdown.reset();
				}
			}
		}
	}

	onSelectSkillset() {
		var questionOptions = this.getQuestionOptions();
		if (!_.includes(questionOptions, this.state.selectedQuestionType)) {
			this.setState({ selectedQuestionType: questionOptions[0].value });
		}
	}

	getQuestionOptions() {
		return [
			{ value: ALL_TEXTS, label: ALL_TEXTS },
			{ value: ALL_FICTION_TEXTS, label: ALL_FICTION_TEXTS },
			{ value: ALL_NONFICTION_TEXTS, label: ALL_NONFICTION_TEXTS },
			{ value: SPECIFIC_TEXT, label: SPECIFIC_TEXT }
		];
	}

	onQuestionBookSelect(book) {
		var bookTitle = book.title.substring(0, 30);
		var ellipsis = (bookTitle == book.title) ? "" : "...";
		var questionTypeText = "For: " + bookTitle + ellipsis;
		this.setState({ selectedBook: book, selectedQuestionType: questionTypeText });
		this.refs.bookSearchModal.hide();
	}

	submitNewQuestion(e) {
		$wr.nope(e)

		if (this.refs.questionBody.validate() & this.refs.skillsetDropdown.validate()) {
			var questionData = { body: this.refs.questionBody.val(), skillset: this.refs.skillsetDropdown.val() };
			// may allow this to be customized later, for now set to all grade levels
			questionData.grade_levels = "0,1,2,3,4,5,6,7,8"

			if (this.state.selectedBook) {
				questionData.type = "text-specific-question";
				questionData.text_id = this.state.selectedBook.text_id;
				// to ensure the student sees the question, even though we know the text_variety
				questionData.text_variety = "fiction-and-non-fiction";
			} else {
				var selectedQuestionType = this.state.selectedQuestionType;
				questionData.type = "generic-question";
				if (selectedQuestionType == ALL_NONFICTION_TEXTS) {
					questionData.text_variety = "non-fiction";
				} else if (selectedQuestionType == ALL_FICTION_TEXTS) {
					questionData.text_variety = "fiction";
				} else {
					questionData.text_variety = "fiction-and-non-fiction";
				}
			}
			CurrentUser.api().postQuestions({ question: questionData }, $wr.apiHandler(function(response) {
				var newQuestion = response.question;
				if (this.state.selectedBook) {
					newQuestion.text = this.state.selectedBook;
				}
				var questionArray = _.clone(this.state.questions || []);
				questionArray.push(newQuestion);
				this.setState({ questions: questionArray }, this.toggleAddingQuestion);
			}.bind(this)));
		}
	}

	submitEditedQuestion(e) {
		$wr.nope(e)

		var editedQuestion = _.find(this.state.questions, function(question) {
			return question.id == this.state.editingID;
		}.bind(this));

		if (this.refs.editedQuestionBody.val() != editedQuestion.body && this.refs.editedQuestionBody.validate()) {
			var questionData = { body: this.refs.editedQuestionBody.val() };
			CurrentUser.api().patchQuestion(editedQuestion.id, { question: questionData }, $wr.apiHandler(function(response) {
				var questionArray = _.map(this.state.questions, function(question) {
					if (question.id == editedQuestion.id) {
						question.body = response.question.body;
					}
					return question;
				});
				this.setState({ questions: questionArray });
				this.toggleEditingQuestion(editedQuestion.id);
			}.bind(this)));
		}
	}

	deleteQuestion(questionID, e) {
		if (this.state.questions.length == 1 && this.refs.toggleQuestions.checked) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Oops!", text: "You need at least one question if you want to use only your questions in Practice Questions.", 
				icon: "exclamation-sign", type: "error"
			});
		} else if (confirm("Are you sure you want to delete this question?")) {
			CurrentUser.api().deleteQuestion(questionID, $wr.apiHandler(function(response) {
				var questionArray = _.clone(this.state.questions).filter(function(question) {
					return question.id != questionID;
				});
				this.setState({ questions: questionArray });
				this.toggleEditingQuestion(questionID);
			}.bind(this)));
		}
	}

	toggleCustomizableQuestionPreference() {


		var preferenceHash = {
			prefer_teacher_practice_questions: !this.props.preferTeacherPracticeQuestions
		}
		this.props.onChange(preferenceHash, "You successfully changed your custom questions preference.");
	}

	render() {
		var headerContent = (
			<p>
				Add and edit your own questions for students to answer in <i>Practice Questions</i>.
			</p>
		);

		if (this.state.questions == null) {
			return (
				<div className="questionCustomizerContainer">
					{ headerContent }
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		if (this.state.questions.length > 0) {
			var existingQuestionsContent = _.map(this.state.questions, function(question) {
				if (this.state.editingID == question.id) {
					var questionDisplay = (
						<form className="editQuestionForm" onSubmit={ this.submitEditedQuestion }>
							<ValidatingInput type="textarea" ref="editedQuestionBody"
								defaultValue={ question.body }
								validators={ ValidatingInput.Validators.PRESENT }
								inputClassName="form-control" />
							<LoadingButton className="btn buttonSuccess" loading={ this.state.loading }
								text="Save" />
							<a className="cancelLink" href="#" 
								onClick={ this.toggleEditingQuestion.bind(this, question.id) }>
								Cancel
							</a>
							<a className="deleteLink" href="#" 
								onClick={ this.deleteQuestion.bind(this, question.id) }>
								Delete Question
							</a>
						</form>
					);
				} else {
					if (question.text) {
						var textTitleDisplay = (
							<span className="textTitle">
								For { question.text.title }:<span className="spacer1" />
							</span>
						);
					}
					var questionDisplay = (
						<div className="existingQuestion">
							<img src={ Skillsets.getIcon(question.skillset) } 
								data-tip={ Skillsets.getName(question.skillset) } />
							<p onClick={ this.toggleEditingQuestion.bind(this, question.id) } >
								{ textTitleDisplay }
								{ question.body }
								<Glyphicon icon={ "pencil" } className={ "editQuestionIcon" } />
							</p>
						</div>
					);
				}

				return (
					<div key={ question.id }>
						{ questionDisplay }
					</div>
				)
			}.bind(this));
		}

		if (this.state.addingQuestion || this.state.questions.length == 0) {
			var questionType = this.state.selectedQuestionType;

			var limitSkillsetsFiction = (questionType == ALL_FICTION_TEXTS)
				|| ((questionType == SPECIFIC_TEXT) && (this.state.selectedBook.text_variety == "fiction"));
			var limitSkillsetsNonFiction = (questionType == ALL_NONFICTION_TEXTS)
				|| ((questionType == SPECIFIC_TEXT) && (this.state.selectedBook.text_variety == "non-fiction"));

			if (limitSkillsetsFiction) {
				var skillsetOptions = DropDownOptions.Button.Skillsets({ fictionOnly: true, readingOnly: true });
			} else if (limitSkillsetsNonFiction) {
				var skillsetOptions = DropDownOptions.Button.Skillsets({ nonFictionOnly: true, readingOnly: true });
			} else {
				var skillsetOptions = DropDownOptions.Button.Skillsets({ readingOnly: true });
			}

			var questionTypes = this.getQuestionOptions();

			var questionTypeOptions = questionTypes.map(function(option) {
				var text = option.label;
				var clickedType = function() {
					this.selectQuestionType(option.label);
				}.bind(this);
				return (
					<ButtonDropdownOption onClick={ clickedType } text={ text } 
						key={ option.value } />
				)
			}.bind(this));

			var bookSearchModal = (
				<BookSearchModal ref="bookSearchModal" onBookSelect={ this.onQuestionBookSelect } />
			);

			var newQuestionContent = (
				<div>
					<form className="newQuestionForm" onSubmit={ this.submitNewQuestion }>
						<ValidatingInput type="textarea" ref="questionBody"
							validators={ ValidatingInput.Validators.PRESENT }
							inputClassName="form-control"
							placeholder="Your new question..." />

						<div className="controls">
							<ValidatingInput type="button-dropdown" defaultText="Choose Skillset"
								validators={ ValidatingInput.Validators.PRESENT }
								errorMessage="Please select a skill set"
								selectOptions={ skillsetOptions } ref="skillsetDropdown"
								className="skillsetDropdown" onChange={ this.onSelectSkillset } />
							<ButtonDropdown text={ questionType } dropdownDisplay="link">
								{ questionTypeOptions }
							</ButtonDropdown>
							<LoadingButton className="btn buttonSuccess" loading={ this.state.loading }
								text="Save" />
							<a className="cancelLink" href="#" onClick={ this.toggleAddingQuestion }>
								Cancel
							</a>
						</div>
					</form>
					{ bookSearchModal }
				</div>
			);
		} else {
			var newQuestionContent = (
				<a className="newQuestionLink" href="#" onClick={ this.toggleAddingQuestion }>
					<Glyphicon icon={ "plus" } />
					<span className="spacer1" />New Question
				</a>
			);
		}

		if (this.state.questions.length > 0) {
			var customQuestionsToggle = (
				<label className="customQuestionsToggle">
					<input type="checkbox" ref="toggleQuestions"
						checked={ this.props.preferTeacherPracticeQuestions }
						onChange={ this.toggleCustomizableQuestionPreference } />
					<span className="defaultLink">
						Use only my custom questions, when applicable, in <em>Practice Questions</em>.
					</span>
				</label>
			);
		}

		return (
			<div className="questionCustomizerContainer">
				{ headerContent }
				{ existingQuestionsContent }
				{ newQuestionContent }
				{ customQuestionsToggle }
				<ReactTooltip effect="solid" />
			</div>
		)
	}

	componentDidMount() {
		var params = {
			user_id: CurrentUser.get().id, user_id_only: true, per_page: 1000,
			embed: "question.text",
			types: "generic-question,text-specific-question"
		}
		CurrentUser.api().getQuestions(params, $wr.apiHandler(function(response) {
			this.setState({ questions: _.sortBy(response.questions, "created_at") });
		}.bind(this)));
	}
}

QuestionCustomizer.WrappedComponent.propTypes = StrictPropTypes({
	preferTeacherPracticeQuestions: PropTypes.bool,
	onChange: PropTypes.func.isRequired
});

var ALL_TEXTS = 'For All Texts';
var ALL_FICTION_TEXTS = 'For All Fiction Texts';
var ALL_NONFICTION_TEXTS = 'For All Nonfiction Texts';
var SPECIFIC_TEXT = 'For A Specific Text';

module.exports = QuestionCustomizer;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/QuestionCustomizer.js